import { useState, useEffect } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, styled } from '@mui/material';
import axiosInstance from '../../lib/axios';
import { toast } from 'react-toastify';
import dayjs from 'dayjs';

// Styling the TableContainer and TableRow for a better design
const StyledTableCell = styled(TableCell)(({ theme }) => ({
    fontSize: '14px',
    padding: '5px',
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: '#f9f9f9',
    },
    '&:hover': {
        backgroundColor: '#f1f1f1',
    },
}));

const AccountingTable = ({ PropId, FromDt, ToDt }) => {

    const [tableData, setTableData] = useState([]);

    useEffect(() => {
        fetchDashboardData();
    }, [PropId])

    const formatTime = (datetime) => {
        return dayjs(datetime).format('hh:mm A');
    };

    const fetchDashboardData = async () => {
        try {
            const response = await axiosInstance.post('AccDashboard/AccDashboard?currentPage=1&limit=15', {
                PropId: PropId,
                FromDt: FromDt,
                ToDt: ToDt,
                Flag: "RecentTrn",
                start: 1,
                PageSize: 10,
                SearchText: ""
            });
            if (response.data.Status === 0) {
                setTableData(response.data.Data);
            }
        } catch (error) {
            toast.error("Error while fetching data.");
        }
    };

    return (
        <TableContainer component={Paper} sx={{ maxWidth: '100%', height: '345px', borderRadius: '5px', boxShadow: 3 }}>
            <Table aria-label="accounting table">
                <TableHead sx={{ '& th': { fontWeight: 'bold', backgroundColor: '#33F2', padding: '3px' } }}>
                    <TableRow>
                        <StyledTableCell >Sr.No</StyledTableCell>
                        <StyledTableCell align="center">DocNo</StyledTableCell>
                        <StyledTableCell align="center">Time</StyledTableCell>
                        <StyledTableCell align="center">Amount</StyledTableCell>
                        <StyledTableCell align="center">Created By</StyledTableCell>
                        <StyledTableCell align="center">TrjType</StyledTableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {tableData.map((row, index) => (
                        <StyledTableRow key={row.id}>
                            <StyledTableCell>{index + 1}</StyledTableCell>
                            <StyledTableCell align="center">{row.DocNo}</StyledTableCell>
                            <StyledTableCell align="center">{formatTime(row.DocDt)}</StyledTableCell>
                            <StyledTableCell align="center">{row.Amount}</StyledTableCell>
                            <StyledTableCell align="center">{row.Name}</StyledTableCell>
                            <StyledTableCell align="center">{row.SearchTxt}</StyledTableCell>
                        </StyledTableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default AccountingTable;
